module.exports = __webpack_public_path__ + "static/img/wd.d5db546.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/vipnotifyProject/images/wd.jpg
// module id = cRaD
// module chunks = 5